module.exports = __webpack_public_path__ + "img/cover-minigame-bg.6d5b1c8b.png";